import { configureStore } from "@reduxjs/toolkit";
import authUserReducer from "./authUser/authUserSlice";
import modalsManagementReducer from "./modalsManagement/modalsManagementSlice";
import toastReducer from "./toast/toastSlice";
import workOrderReducer from "./workOrder/workOrderSlice";
import filtersReducer from "./filters/filtersSlice";
import clientFiltersReducer from "./filters/clientFiltersSlice";
import workforceFiltersReducer from "./filters/workforceFiltersSlice";
import freelanceCompanyWorkforceFiltersReducer from "./filters/freelanceCompanyWorkforceFiltersSlice";
import talentPoolFiltersReducer from "./filters/talentPoolFiltersSlice";
import engineersReducer from "./engineers/engineerSlice";
import engineerFiltersReducer from "./filters/engineerFiltersSlice";
import adminFiltersReducer from "./filters/adminFiltersSlice";
import clientDashboardFiltersReducer from "./filters/clientDashboardFilterSlice";
import invoiceFiltersReducer from "./filters/invoiceFilterSlice";
import taskBoardFiltersReducer from "./filters/taskBoardFiltersSlice";
export const store = configureStore({
  reducer: {
    authUser: authUserReducer,
    modalsManagement: modalsManagementReducer,
    toast: toastReducer,
    workOrder: workOrderReducer,
    filters: filtersReducer,
    clientFilters: clientFiltersReducer,
    workforceFilters: workforceFiltersReducer,
    freelanceCompanyWorkforceFilters: freelanceCompanyWorkforceFiltersReducer,
    talentPoolFilters: talentPoolFiltersReducer,
    engineerFilters: engineerFiltersReducer,
    adminFilters: adminFiltersReducer,
    invoiceFilters: invoiceFiltersReducer,
    engineers: engineersReducer,
    clientDashboardFilters: clientDashboardFiltersReducer,
    taskBoardFilters: taskBoardFiltersReducer,
  },
});
